import React from "react";
import { motion } from "framer-motion";

const items = [
  { big: "20", unit: "ACRES", label: "Urban forest grown over Rajkot's old dumpsite" },
  { big: "16", unit: "LAKH TONNES", label: "Legacy waste processed in Rajkot" },
  { big: "100", unit: "%", label: "Source segregation achieved in Agra under SBM-U" },
  { big: "45K+", unit: "CITIZENS", label: "Joined Morbi's mass cleanliness drive" },
  { big: "248", unit: "TPD", label: "Daily waste Morbi now actively processes" },
];

const MarqueeRow = ({ reverse = false }) => (
  <div className="marquee-track" style={{ animationDirection: reverse ? "reverse" : "normal" }}>
    {[...items, ...items].map((it, i) => (
      <div
        key={i}
        className="flex items-center gap-6 shrink-0"
        data-testid={`marquee-item-${i}`}
      >
        <span className="font-display font-extrabold text-[18vw] sm:text-[14vw] lg:text-[10vw] leading-none tracking-tight text-[color:var(--mati-sand)]">
          {it.big}
        </span>
        <div className="pb-6 sm:pb-8 lg:pb-10 max-w-[220px]">
          <div className="font-mono-ui text-[10px] tracking-[0.28em] text-[color:var(--mati-clay)]">
            {it.unit}
          </div>
          <div className="font-sub text-sm text-[color:var(--mati-sand)]/80 mt-2 leading-snug">
            {it.label}
          </div>
        </div>
        <span className="font-display text-[color:var(--mati-clay)] text-6xl opacity-60 pb-4">
          /
        </span>
      </div>
    ))}
  </div>
);

export const ResultsMarquee = () => {
  return (
    <section
      id="impact"
      className="relative py-28 sm:py-36 bg-[color:var(--mati-forest)] text-[color:var(--mati-sand)] overflow-hidden"
      data-testid="results-marquee"
    >
      <div className="absolute inset-0 ceramic-grid-dark opacity-30" />

      <div className="relative max-w-[1360px] mx-auto px-5 sm:px-8 lg:px-12 mb-14">
        <div className="grid grid-cols-12 gap-6 lg:gap-10 items-end">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
            className="col-span-12 lg:col-span-7"
          >
            <div className="eyebrow text-[color:var(--mati-clay)]">
              04 · What's Possible
            </div>
            <h2 className="font-display font-bold text-5xl sm:text-6xl lg:text-7xl mt-5 leading-[0.95] tracking-tight">
              Cities that{" "}
              <span className="italic text-[color:var(--mati-clay)]">
                acted
              </span>{" "}
              — and what changed.
            </h2>
          </motion.div>
          <motion.p
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1], delay: 0.1 }}
            className="col-span-12 lg:col-span-5 font-sub text-base sm:text-lg opacity-80 leading-relaxed"
          >
            A slow editorial ticker of verified benchmarks from across India —
            proof that civic effort, when sustained, bends the curve.
          </motion.p>
        </div>
      </div>

      <div className="relative overflow-hidden border-y border-[color:var(--mati-border-dark)]">
        <div className="py-6 sm:py-10">
          <MarqueeRow />
        </div>
      </div>
      <div className="relative overflow-hidden border-b border-[color:var(--mati-border-dark)]">
        <div className="py-6 sm:py-10">
          <MarqueeRow reverse />
        </div>
      </div>

      <div className="relative max-w-[1360px] mx-auto px-5 sm:px-8 lg:px-12 mt-12 flex flex-wrap gap-x-10 gap-y-4 text-[color:var(--mati-sand)]/60 font-mono-ui text-[10px] tracking-[0.28em]">
        <span>SOURCE · SWACHH BHARAT MISSION (URBAN)</span>
        <span>MORBI MUNICIPAL CORPORATION</span>
        <span>SWACHH SURVEKSHAN FIELD REPORTS</span>
      </div>
    </section>
  );
};

export default ResultsMarquee;
